import React, { createContext, useState, useEffect } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [codigoCondominio, setCodigoCondominio] = useState(null);
    const [nomeUsuario, setNomeUsuario] = useState(null);
    const [emailUsuario, setEmailUsuario] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        // Verifica se há dados armazenados no localStorage
        const storedCodigoCondominio = localStorage.getItem("codigoCondominio");
        const storedNomeUsuario = localStorage.getItem("nomeUsuario");
        const storedEmailUsuario = localStorage.getItem("emailUsuario");

        if (storedCodigoCondominio && storedNomeUsuario && storedEmailUsuario) {
            setCodigoCondominio(storedCodigoCondominio);
            setNomeUsuario(storedNomeUsuario);
            setEmailUsuario(storedEmailUsuario);
            setIsAuthenticated(true);
        } else {
            setIsAuthenticated(false);
        }
    }, []);

    // Função para realizar login
    const login = (codigo, nome, email) => {
        localStorage.setItem("codigoCondominio", codigo);
        localStorage.setItem("nomeUsuario", nome);
        localStorage.setItem("emailUsuario", email);

        setCodigoCondominio(codigo);
        setNomeUsuario(nome);
        setEmailUsuario(email);
        setIsAuthenticated(true);
    };

    // Função para realizar logout
    const logout = () => {
        localStorage.removeItem("codigoCondominio");
        localStorage.removeItem("nomeUsuario");
        localStorage.removeItem("emailUsuario");

        setCodigoCondominio(null);
        setNomeUsuario(null);
        setEmailUsuario(null);
        setIsAuthenticated(false);
    };

    return (
        <UserContext.Provider
            value={{
                codigoCondominio,
                nomeUsuario,
                emailUsuario,
                isAuthenticated,
                login,
                logout,
            }}
        >
            {children}
        </UserContext.Provider>
    );
};

